/**
 * A crase antes de uma hora, num lugar só (a revisão da tela de 30/09).
 *
 * "À uma hora" e "à zero hora" são singulares; de duas horas em diante, "às".
 * As telas das avaliações escreviam «às» antes de qualquer hora, e a frase da
 * importação, na primeira dobra da Visão geral, dizia «até 30/09/2026, às
 * 01:12». O mesmo vale para a faixa da dica do gráfico por hora: «da 00h à
 * 01h», «da 01h às 02h», «das 02h às 03h».
 *
 * O módulo é PURO — zero import, nem de tipo —, como `slug.ts`: a prova
 * (`tests/hora-no-texto.mjs`) o carrega solto, sem montar o resto do app.
 */

/** A hora (0 a 24) de um texto como "01:12" ou "13h33", ou de um número. */
function horaDe(hora: string | number): number {
  if (typeof hora === "number") return hora;
  return Number.parseInt(hora, 10);
}

/** «à» diante da zero hora e da uma hora; «às» nas outras. */
export function artigoDaHora(hora: string | number): "à" | "às" {
  const h = horaDe(hora);
  return h === 0 || h === 1 ? "à" : "às";
}

/** «da» diante da zero hora e da uma hora; «das» nas outras (o começo de uma faixa). */
export function contracaoDaHora(hora: string | number): "da" | "das" {
  const h = horaDe(hora);
  return h === 0 || h === 1 ? "da" : "das";
}

/** A hora com a crase certa: «às 13:33», «à 01:12». */
export function horaComArtigo(hora: string): string {
  return `${artigoDaHora(hora)} ${hora}`;
}

/** A faixa de uma hora cheia, como a dica do gráfico a escreve: «da 00h à 01h», «das 23h às 24h». */
export function faixaDaHora(h: number): string {
  const de = String(h).padStart(2, "0");
  const ate = String(h + 1).padStart(2, "0");
  return `${contracaoDaHora(h)} ${de}h ${artigoDaHora(h + 1)} ${ate}h`;
}
